module.exports = __webpack_public_path__ + "img/bz7.26a62f56.png";